import React, { useEffect } from "react";

const ZendeskChat = () => {
    useEffect(() => {
        if (!window.$zopim) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.charset = "utf-8";
            script.src = "https://v2.zopim.com/?4pkaL7DsKn4v0g7nXt0wWhTNH3FA8b86";

            document.head.appendChild(script);
        }

        return () => {
            // Cleanup if needed
            if (document.head.querySelector(`script[src="https://v2.zopim.com/?4pkaL7DsKn4v0g7nXt0wWhTNH3FA8b86"]`)) {
                document.head.removeChild(
                    document.head.querySelector(`script[src="https://v2.zopim.com/?4pkaL7DsKn4v0g7nXt0wWhTNH3FA8b86"]`)
                );
            }
        };
    }, []);

    return null;
};

export default ZendeskChat;
